import React from "react";
import context from "../../lib/context.js";

export default class LoadingPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <table className="ap-loading-panel">
                <tbody>
                    <tr>
                        <td className="text-center" valign="middle">
                            <img className="ap-loading-icon" src={context.url("images", "preloader.gif")} /> <span>{this.props.message}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}